module.exports = __webpack_public_path__ + "img/htsslogo.70f607a6.png";